import { createSlice } from "@reduxjs/toolkit";
import { initialApiState } from "../common";
import initialState from "./initialState";
import { fetchAllDailyTasks } from "./thunks";

const schedulerSlice = createSlice({
  name: "schedulerSlice",
  initialState,
  reducers: {
    addCompletedTaskToSync: (state, action) => {
      if (action.payload && !state.tasksToSync.includes(action.payload))
        state.tasksToSync = state.tasksToSync?.concat(action.payload);
    },
    clearTasksToSync: (state, _action) => {
      state.tasksToSync = [];
    },
    setDailyTasksToDelete: (state, action) => {
      state.tasksToDelete = action.payload;
    },
    clearDailyTasksToDelete: (state, _action) => {
      state.tasksToDelete = [];
    },
    addTaskToList: (state, action) => {
      if (action.payload)
        state.tasks.data = state.tasks.data.concat(action.payload);
    },
    setTasksLastSyncDate: (state, action) => {
      state.lastSync = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllDailyTasks.pending, (state, _action) => {
      state.tasks.state = "pending";
      state.tasks.error = null;
    });
    builder.addCase(fetchAllDailyTasks.fulfilled, (state, action) => {
      state.tasks.state = "success";
      state.tasks.data = action.payload;
      state.tasks.error = null;
    });
    builder.addCase(fetchAllDailyTasks.rejected, (state, action) => {
      state.tasks.state = "failed";
      state.tasks.data = null;
      state.tasks.error = action.error;
    });
    builder.addCase("common/cleanup", (state, _action) => {
      state.tasks = initialApiState;
      state.tasksToSync = [];
      state.tasksToDelete = [];
    });
  },
});

export const {
  addCompletedTaskToSync,
  addTaskToList,
  clearTasksToSync,
  setDailyTasksToDelete,
  clearDailyTasksToDelete,
  setTasksLastSyncDate,
} = schedulerSlice.actions;
export default schedulerSlice.reducer;
